import { AfterViewInit, Component, HostListener, OnInit } from '@angular/core';
import { APP_CONSTANTS as CONST } from '@app/app.constants';
import { ETRANSACTION_STATUS } from '@app/core/enums/app.enum';
import { Observable, Subject, timer } from 'rxjs';
import { scan, takeUntil, takeWhile } from 'rxjs/operators';
import { APP_ROUTES as ROUTES } from '../../../app.routes';
import { ILargeContentConfig } from '../../../core/models/app.model';
import { IOnboardingKYC } from '../../../core/models/onboarding.model';
import { AppFacade } from '../../../facades/app.facade';
import { OnboardingFacade } from '../../../facades/onboarding.facade';
import { UIService } from '../../../services/ui.service';

@Component({
  selector: 'app-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.scss'],
})
export class BaseComponent implements OnInit, AfterViewInit {
  public isLargeScreen: boolean;
  public currentRoute$: Observable<string>;
  public currentFlow$: Observable<string>;
  public step$: Observable<number>;
  public auth10tix$: Observable<IOnboardingKYC>;
  public isLargeContent$: Observable<ILargeContentConfig>;
  public startTimer$: Observable<number>;
  public time: number = 0;
  public stopTimer$: Subject<boolean> = new Subject();
  public clickEvent: boolean = false;
  public openMenu$: Observable<boolean>;
  public ROUTES = ROUTES;
  public transactionStatus$: Observable<string>;
  public ETRANSACTION_STATUS = ETRANSACTION_STATUS;

  constructor(
    private _appFacade: AppFacade,
    private _uiService: UIService,
    private _onboardingFacade: OnboardingFacade
  ) {}
  @HostListener('window:resize', ['$event'])
  public _checkIsLarge() {
    this._setViewLarge();
  }

  ngOnInit(): void {
    this.isLargeScreen = window.innerWidth > CONST.SIZE_MOBILE_SCREEN;
    this._setValues();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      const isLargeContent: ILargeContentConfig = this._uiService.isLargeContent();
      this._appFacade.setLargeContentConfig(isLargeContent);
    }, 500);
  }

  private _setValues() {
    this.step$ = this._appFacade.step$;
    this.currentRoute$ = this._appFacade.currentRoute$;
    this.currentFlow$ = this._appFacade.currentFlow$;
    this.isLargeContent$ = this._appFacade.largeContentConfig$;
    this.auth10tix$ = this._onboardingFacade.auth10tix$;
    this.startTimer$ = timer(0, 1000).pipe(
      scan((acc) => --acc, 15),
      takeWhile((time) => time >= 0),
      takeUntil(this.stopTimer$)
    );
    this.currentRoute$.subscribe((route) => {
      if (route === ROUTES.ERROR || route === ROUTES.PAYMENT) this._onStartTimer();
    });
    this.openMenu$ = this._appFacade.openMenu$;
    this.transactionStatus$ = this._appFacade.transactionStatus$;
  }

  private _onStartTimer() {
    this.startTimer$.subscribe((timer) => (this.time = timer));
  }

  private _setViewLarge(): void {
    this.isLargeScreen = window.innerWidth > CONST.SIZE_MOBILE_SCREEN;
  }

  public onGoBack(event: boolean): void | boolean {
    return !!event ? this._appFacade.goToStepBack() : false;
  }

  public onReceiveClickEvent(event: boolean) {
    this._appFacade.handleMenu();
  }

  public onCloseMenu(event: boolean) {
    this._appFacade.closeMenu();
  }
}
